
import EoToolbar from '../EoToolbar/EoToolbar'
import EoDrawer from '../EoDrawer/EoDrawer'
import EoButton from '../EoButton/EoButton'
import EoIcon from '../EoIcon/EoIcon'

import EoSearchFilterList from './EoSearchFilterList'

export default {
  name: 'EoSearchFilters',
  components: {
    EoToolbar,
    EoDrawer,
    EoButton,
    EoIcon,
    EoSearchFilterList,
  },
  props: {
    darkMode: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    /**
     * Open or close the mobile drawer
     */
    drawerOpen: {
      type: Boolean,
      default: false,
    },
    /*
     * Style: color used on buttons
     */
    buttonColor: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      filters: {},
      isDrawerOpen: false,
    }
  },
  computed: {
    spaceForHeader () {
      return this.$library.application?.spaceForHeader || null
    },
    spaceForFooter () {
      return this.$library.application?.spaceForFooter || null
    },
  },
  watch: {
    value: 'onUpdatedValue',
    filters: 'onUpdatedFilters',
    drawerOpen: 'onUpdatedDrawerOpen',
    isDrawerOpen: 'onUpdatedIsDrawerOpen',
  },
  created () {
    this.onUpdatedValue()
    this.onUpdatedDrawerOpen()
  },
  methods: {
    onUpdatedValue () {
      this.filters = this.value
    },
    onUpdatedFilters (filters) {
      /**
       * Emitted when the filters have changed
       * @event input
       */
      this.$emit('input', filters)
    },
    onUpdatedDrawerOpen (isDrawerOpen) {
      this.isDrawerOpen = isDrawerOpen
    },
    onUpdatedIsDrawerOpen (isDrawerOpen) {
      /**
       * Emitted when the user closes or opens the drawer from within
       * @event toggle
       */
      this.$emit('toggle-drawer', isDrawerOpen)
    },
  },
}
